import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    maxHeight: theme.spacing(35),
    overflowY: 'auto',
    '& thead th': {
      position: 'sticky',
      top: 0,
      zIndex: 99,
      backgroundColor: theme.palette.background.default,
    },
    '& tbody td': {
      position: 'relative',
      zIndex: 1,
    },
  },
  empty: {
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
